import { Client, KickEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType, tabType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class KickEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.KICK, (event: KickEvent) => {
            const { kicked, nick, ident, hostname, channel, message, time, account, tags, batch } = event;
            const ourNick = this.client?.user.nick;

            if (kicked === ourNick) {
                this.tM.closeTab(channel);
                const statusTab = this.tM.getStatusTab();
                this.tM.setActiveTab(statusTab);
                this.mH.addMessage(statusTab, `* You were kicked from ${channel} by ${nick} (${message || 'No reason provided'})`, IRCMessageType.SYSTEM);
            } else {
                const channelTab = this.tM.getTab(tabType.CHANNEL, channel);
                if (channelTab) {
                    this.mH.addMessage(channelTab, `* ${kicked} was kicked from ${channel} by ${nick} (${message || 'No reason provided'})`, IRCMessageType.SYSTEM);
                }
                this.cH.refreshUserList(channel);
            }
        });
    }
}
